import { useMutation } from '@tanstack/react-query';

import {
  API_ENDPOINT_KEYS,
  MUTATION_KEY,
  SERVICE_AUTH_ENDPOINTS,
} from '~common';
import { postAuthRequest } from '~services';

export interface ForgotPasswordRequest {
  email: string;
  redirectUrl: string;
}

export const useForgotPasswordMutation = () => {
  const mutationFn = (reqBody: ForgotPasswordRequest) => {
    return postAuthRequest({
      path: SERVICE_AUTH_ENDPOINTS[API_ENDPOINT_KEYS.FORGOT_PASSWORD],
      data: reqBody,
      ignoreAuthHeader: true,
    });
  };

  return useMutation({
    mutationKey: [MUTATION_KEY.FORGOT_PASSWORD],
    mutationFn,
  });
};
